import { render, staticRenderFns } from "./KitchenSinkFormStep4.vue?vue&type=template&id=55b888f6&"
import script from "./KitchenSinkFormStep4.vue?vue&type=script&lang=ts&"
export * from "./KitchenSinkFormStep4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports